/* Product page v2 (Oct 2026). Runs alongside hf-home.js, which owns the tile
   (gallery, swatches, size tabs, Buy now). This adds:
   - Add to cart (secondary): follows Buy now's state (disabled until a size is
     picked, same variant), adds 1 and opens the theme's cart drawer the same
     way the theme's own product form does; "Added ✓" for 1.5s.
   - Testimonials "See all testimonials" / "Show less". */
(function () {
  if (window.__pdpV2) return;
  window.__pdpV2 = true;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function initAdd(tile) {
    var buy = $('[data-buy]', tile);
    var add = $('[data-pdp-add]', tile);
    var msg = $('[data-buy-msg]', tile);
    if (!buy || !add) return;
    var busy = false;
    function sync() {
      if (busy) return;
      add.disabled = false;
      add.setAttribute('aria-disabled', (buy.getAttribute('aria-disabled') === 'true' || !buy.dataset.variant) ? 'true' : 'false');
      add.dataset.variant = buy.dataset.variant || '';
    }
    new MutationObserver(sync).observe(buy, { attributes: true, attributeFilter: ['aria-disabled', 'data-variant'] });
    sync();

    add.addEventListener('click', function () {
      if (busy) return;
      if (add.getAttribute('aria-disabled') === 'true') { if (tile.__hfPromptSize) tile.__hfPromptSize(); return; }
      var id = add.dataset.variant;
      if (!id) return;
      busy = true;
      /* Optimistic (Oct 20): confirm straight away; the drawer opens when Shopify answers,
         and an error puts the button back with the message. No busy cursor. */
      add.classList.add('is-added');
      add.textContent = add.dataset.added || 'Added';
      if (msg) msg.textContent = '';
      var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var fd = new FormData();
      fd.append('id', id);
      fd.append('quantity', '1');
      if (cart && cart.getSectionsToRender) {
        fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.section; }));
        fd.append('sections_url', window.location.pathname);
        if (cart.setActiveElement) cart.setActiveElement(add);
      }
      var url = (window.routes && window.routes.cart_add_url) || ((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add');
      fetch(url, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd })
        .then(function (r) { return r.text().then(function (t) { var d; try { d = JSON.parse(t); } catch (e) { throw new Error('blocked'); } return d; }); })
        .then(function (data) {
          if (data.status && data.description) { var err = new Error(data.description); err.userFacing = true; throw err; }
          if (cart && cart.renderContents) cart.renderContents(data);
          else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          if (typeof window.updateCartCounters === 'function') window.updateCartCounters();
          setTimeout(function () {
            add.classList.remove('is-added');
            add.textContent = add.dataset.label;
            busy = false; sync();
          }, 1500);
        })
        .catch(function (err) {
          add.classList.remove('is-added');
          add.textContent = add.dataset.label;
          busy = false; sync();
          if (err && err.userFacing) { if (msg) msg.textContent = err.message; return; }
          /* request blocked (bot check etc.): plain form post so Shopify can verify first */
          var f = document.createElement('form');
          f.method = 'post'; f.action = '/cart/add'; f.style.display = 'none';
          [['id', id], ['quantity', '1'], ['return_to', '/cart']].forEach(function (kv) {
            var i = document.createElement('input'); i.type = 'hidden'; i.name = kv[0]; i.value = kv[1]; f.appendChild(i);
          });
          document.body.appendChild(f); f.submit();
        });
    });
  }

  function initQuotes(root) {
    var btn = $('[data-pdp-more]', root);
    if (!btn) return;
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') !== 'true';
      $$('[data-extra]', root).forEach(function (li) { li.hidden = !open; });
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? btn.dataset.less : btn.dataset.more;
      if (!open) {
        var y = root.getBoundingClientRect().top + window.pageYOffset - 80;
        if (y < window.pageYOffset) window.scrollTo({ top: y });
      }
    });
  }

  function init() {
    $$('[data-pdp-tile]').forEach(initAdd);
    $$('[data-pdp-quotes]').forEach(initQuotes);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { window.__pdpV2 = false; });
})();
